import { useEffect, useRef, useState } from 'react';
import { DEFAULT_COMPANY_LOGO, applyLogoFallback } from '@/utils/logoFallback';
import { TemplateLogoCache } from '@/utils/templateLogoCache';

export default function ProviderLogo({ src, name, cache }: { src: string; name: string; cache: TemplateLogoCache }) {
  const image = useRef<HTMLImageElement>(null);
  const [loaded, setLoaded] = useState({ source: '', url: DEFAULT_COMPANY_LOGO });
  useEffect(() => {
    let alive = true;
    let started = false;
    const load = () => {
      if (started) return;
      started = true;
      void cache.load(src).then(url => { if (alive) setLoaded({ source: src, url }); });
    };
    const observer = typeof IntersectionObserver !== 'undefined' ? new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer?.disconnect(); load(); }
    }, { rootMargin: '200px' }) : null;
    if (observer && image.current) observer.observe(image.current);
    else load();
    return () => { alive = false; observer?.disconnect(); };
  }, [src, cache]);
  return <img ref={image} width="150" style={{ maxWidth: '100%', height: 'auto' }}
    src={loaded.source === src ? loaded.url : DEFAULT_COMPANY_LOGO} alt={name}
    decoding="async" onError={event => applyLogoFallback(event.currentTarget)} />;
}
